import { __assign } from "tslib";
import TextFieldWrapper, { getAccessibilityAttributes, splitProps, VARIANT } from '@mos-cat/text-field-wrapper';
import cx from 'classnames';
import * as React from 'react';
import { forwardRef } from 'react';
import './styles.scss';
/**
 * Референсная имплементация текстового поля с помощью TextFieldWrapper.
 * Имплементируя текстовые поля или расширяя функционал существующих мы обязательно должны использовать проброс референса к нативному текстововму полю, поскольку именно оно чаще всего подвергается модификациям. К тому же от текстового поля проще легко получить доступ к лейблу и произвести поиск всех связанных компонентов через `aria`-аттрибуты.
 * @param props
 * @param ref
 * @constructor
 */
function TextField(props, ref) {
    /**
     * Специальный хелпер помогает разделить все свойства на две части - для TextFieldWrapper и остальные
     */
    var _a = splitProps(props), tfwProps = _a.tfwProps, otherProps = _a.otherProps;
    var classNames = cx('TextField', tfwProps.className);
    /**
     * Специальный хелпер помогает сгенерировать id для aria-аттрибутов.
     */
    var a11yAttr = getAccessibilityAttributes(props.id || props.name);
    /**
     * Поле может описываться текстом из нескольких элементов.
     * Например у нас может быть лебйл ("Пароль") (аттрибут `aria-labelledby`), описание правил ввода: ("Пароль должен содержать не менее 400 символов, включая как минимум один китайский иероглиф, два слова на фарси, специальные символы и первые 30 знаков числа Пи") и ошибка ("Введите пароль").
     *
     * Последнее генерируется автоматически внутри TextFieldWrapper, если ошибка является строкой и через аттрибут aria-describedby прикрепляется к текстовому полю. Чтобы не потерять все остальные описания мы собираем их в список из id.
     *
     * Если ошибка отображается в другом месте, например в поповере, мы можем пробросить его id в area-describedby и в поле передать ошибку типа `boolean`.
     */
    var ariaDescribedby = [props['aria-describedby']]
        .concat(props.error && a11yAttr.describedBy)
        .filter(Boolean)
        .join(' ') || undefined;
    return (React.createElement(TextFieldWrapper, __assign({}, tfwProps, { controlId: props.id || props.name, className: classNames }),
        React.createElement("input", __assign({ ref: ref }, otherProps, { className: "TextField__control", "aria-describedby": ariaDescribedby, "aria-labelledby": a11yAttr.labelledBy }))));
}
export default Object.assign(forwardRef(TextField), { VARIANT: VARIANT });
export { VARIANT };
//# sourceMappingURL=TextField.js.map